import { render, staticRenderFns } from "./RecordsConsumption.vue?vue&type=template&id=508817ce&scoped=true&"
import script from "./RecordsConsumption.vue?vue&type=script&lang=js&"
export * from "./RecordsConsumption.vue?vue&type=script&lang=js&"
import style0 from "./RecordsConsumption.vue?vue&type=style&index=0&id=508817ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508817ce",
  null
  
)

export default component.exports